export default "__VITE_ASSET__BLXJPqjv__"